angular.module('relayHealth').factory('permissionsManager', () => relaylib.permissions.permissionsManager.instance);
